<template>
    <v-row no-gutters>
        <v-col cols="12" class="d-flex align-center mb-3">
            <div class="d-inline-block mr-5">
                <switch-button
                    :value="controller.model.getFirstRowIsHeader()"
                    :label="$t('First row is a header')"
                    @change="controller.model.setFirstRowIsHeader($event)"
                />
            </div>
            <!--dropdown
                :items="controller.model.getAvailableFields()"
                name-key="title"
                value-key="id"
                deselect
                @input="controller.addStaticField($event)"
            >
                <template v-slot="{ on }">
                    <action-button text-transform-normal @click="on['click']">
                        {{ $t("Add field to all clients") }}
                    </action-button>
                </template>
                <template v-slot:actions>
                    <action-button text-transform-normal @click="controller.openAddCustomFieldDialog()">
                        {{ $t("Add client custom field") }}
                    </action-button>
                </template>
            </dropdown-->
            <action-button text-transform-normal @click="addClientGroup">
                {{ $t("Add client group") }}
            </action-button>
            <action-button text-transform-normal @click="controller.openAddCustomFieldDialog()">
                {{ $t("Add client custom field") }}
            </action-button>
            <CustomFieldEditDialog
                v-if="controller.model.isAddCustomFieldDialogVisible()"
                :show-dialog="controller.model.isAddCustomFieldDialogVisible()"
                :account-id="controller.model.getCompanyId()"
                :custom-field-id="0"
                :related-type="CUSTOM_FIELD_RELATED_TYPE.CLIENT"
                @close="controller.closeAddCustomFieldDialog()"
                @save="controller.updateCustomFields()"
            ></CustomFieldEditDialog>
        </v-col>
    </v-row>
</template>

<script>
import Controller from "./controller";
import { CUSTOM_FIELD_RELATED_TYPE } from "@/helpers/constants";
import DialogModule from "@/store/modules/dialog";
import CustomFieldEditDialog from "@/components/Dialog/CustomFieldEditDialog/Index";
import FieldControl from "@/views/Import/Xlsx/Settings/FieldControl";

export default {
    name: "ImporterSettingsViewOptions",
    components: {
        CustomFieldEditDialog,
        FieldControl
    },
    props: {
        controller: {
            type: Controller,
            required: true
        }
    },
    setup(props) {
        const { setDialogOptions, openDialog } = DialogModule();

        const addClientGroup = () => {
            setDialogOptions({
                component: () => import("@/views/Dialog/EditClientGroupDialog"),
                payload: { account_id: props.controller.model.getCompanyId() }
            });
            openDialog();
        };

        return {
            CUSTOM_FIELD_RELATED_TYPE,
            addClientGroup
        }
    }
};
</script>
